export default __webpack_public_path__ + "static/media/3.baf88cc3.gif";